import getFeature from "@template/helpers/getFeature";
import { MENA_FEATURE_KEY } from "./constants";

const parseCountryCodes = countryCodes =>
  typeof countryCodes === "string"
    ? countryCodes
        .split(",")
        .map(code => code.trim().toUpperCase())
        .filter(Boolean)
    : [];

// Relies on the `countryCodes` default being "", so a disabled flag yields no countries.
export const isMenaCountry = async countryCode => {
  const feature = await getFeature(MENA_FEATURE_KEY);
  const { countryCodes } = feature?.getVariables() || {};

  return parseCountryCodes(countryCodes).includes(countryCode);
};
